var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(-849 -190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    transform: "translate(592 195)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy-2",
    "data-name": "Oval Copy",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    transform: "translate(262)",
    fill: "#0959d9",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy-3",
    "data-name": "Oval Copy",
    transform: "translate(262)",
    fill: "none",
    stroke: "#0959d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "np_smile_3092207_000000",
    transform: "translate(863 204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M37.242.129a1.136,1.136,0,0,0-1.561.539A18.561,18.561,0,0,1,18.942,11.049,18.557,18.557,0,0,1,2.2.668,1.185,1.185,0,0,0,.643.129,1.185,1.185,0,0,0,.1,1.69a20.965,20.965,0,0,0,7.619,8.4,21.072,21.072,0,0,0,11.219,3.239A21.215,21.215,0,0,0,30.162,10.09a21.412,21.412,0,0,0,7.619-8.4A1.136,1.136,0,0,0,37.242.129Z",
    transform: "translate(10.638 37.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.671,5.278a1.136,1.136,0,0,0,1.561-.539A4.472,4.472,0,0,1,6.193,2.278a4.472,4.472,0,0,1,3.961,2.461,1.111,1.111,0,0,0,1.02.661,1.771,1.771,0,0,0,.539-.12,1.185,1.185,0,0,0,.539-1.561A6.755,6.755,0,0,0,6.19,0,6.824,6.824,0,0,0,.129,3.72,1.134,1.134,0,0,0,.67,5.278Z",
    transform: "translate(13.01 16.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.67,5.278a1.136,1.136,0,0,0,1.561-.539A4.472,4.472,0,0,1,6.192,2.278a4.472,4.472,0,0,1,3.961,2.461,1.111,1.111,0,0,0,1.02.661,1.771,1.771,0,0,0,.539-.12A1.185,1.185,0,0,0,12.25,3.72,6.755,6.755,0,0,0,6.189,0,6.824,6.824,0,0,0,.128,3.72,1.136,1.136,0,0,0,.669,5.278Z",
    transform: "translate(34.13 16.861)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappy);
export default __webpack_public_path__ + "static/media/icon-happy.c25881486651eb31884b1c3149920ecd.svg";
export { ForwardRef as ReactComponent };